module.exports = {"610329100":"九成宫镇","610329101":"崔木镇","610329102":"招贤镇","610329103":"两亭镇","610329105":"常丰镇","610329106":"丈八镇","610329107":"酒房镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610329.json
// module id = 2595
// module chunks = 0